import {
  ref, watch, computed,
} from '@vue/composition-api';
import store from '@/store';
// Notification
import { useToast } from 'vue-toastification/composition';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

export default function useUsersList(nameModule) {
  // Use toast
  const toast = useToast();
  const refDataTableTemplateImagem = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: 'familia_comercial_id', label: 'Cód. Referência', sortable: false },
    { key: 'familia_comercial_descricao', label: 'Referência', sortable: true },
    { key: 'cod_marca', label: 'Cód. Marca', sortable: true },
    { key: 'des_marca', label: 'Desc. Marca', sortable: true },
    { key: 'actions', label: 'Ações', sortable: false },
  ];
  const perPage = ref(10);
  const totalTemplateImagem = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref('');
  const sortBy = ref('log_img_id');
  const isSortDirDesc = ref(true);

  const dataMeta = computed(() => {
    const localItemsCount = refDataTableTemplateImagem.value ? refDataTableTemplateImagem.value.localItems.length : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalTemplateImagem.value,
    };
  });

  const refetchData = () => {
    refDataTableTemplateImagem.value.refresh();
  };

  watch([currentPage, perPage, searchQuery], () => {
    refetchData();
  });

  const pagination = computed({
    get() {
      return store.getters['slsTemplateImagem/getFilters'];
    },
    set(value) {
      store.commit('slsTemplateImagem/setFilters', value);
    },
  });

  const fetchTemplateImagem = (ctx, callback) => {
    try {
      store.commit('slsTemplateImagem/setShowLoading', true);

      const params = {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
      };

      store
        .dispatch('slsTemplateImagem/findAll', params)
        .then((response) => {
          const paginations = response.paginations || response;
          const { data } = response;
          const page = Number(paginations.page) || currentPage.value;
          const currentPerPage = Number(paginations.perPage) || perPage.value;
          const total = Number(paginations.total) || 0;
          currentPage.value = page;
          perPage.value = currentPerPage;
          totalTemplateImagem.value = total;
          callback(data);
        })
        .catch((error) => {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error ao carregar dados',
              text: error.message,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          });
        })
        .finally(() => {
          store.commit('slsTemplateImagem/setShowLoading', false);
        });
    } catch (e) {
      store.commit('slsTemplateImagem/setShowLoading', false);
    }
  };

  return {
    fetchTemplateImagem,
    tableColumns,
    perPage,
    currentPage,
    totalTemplateImagem,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refDataTableTemplateImagem,

    refetchData,
  };
}
